import html2pdf from 'html2pdf.js/dist/html2pdf.min.js';
import i18n from "i18next";

export const downloadCSV = (data, headers, filename) => {
  let csv = headers.join(",") + "\n";

  data.forEach((row) => {
    csv += row.join(",") + "\n";
  });

  const blob = new Blob([csv], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${filename}.csv`;

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(url);
};


export const formatDate = (isoDate) => {
  const date = new Date(isoDate);
  return `${date.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  })} on ${date.toLocaleDateString()}`;
};

export const capitalizeFirst = (str) =>
    str ? str.charAt(0).toUpperCase() + str.slice(1) : "";

export const formatAge = (birthDate, lng) => {
  if (!birthDate) return "---";
  const isAr = lng === 'ar';
  const today = new Date();
  const birth = new Date(birthDate);

  let years = today.getFullYear() - birth.getFullYear();
  let months = today.getMonth() - birth.getMonth();

  if (today.getDate() < birth.getDate()) months--;
  if (months < 0) {
    years--;
    months += 12;
  }

  const yearsStr = isAr ? 'سنه' : 'year';
  const monthsStr = isAr ? 'شهر' : 'month';

  return isAr 
    ? `${years} ${yearsStr} و ${months} ${monthsStr}` 
    : `${years} ${yearsStr}, ${months} ${monthsStr}`;
};


export const translateAgeString = (ageString) => {
  if (!ageString || ageString === "---") return ageString;
  
  const isAr = i18n.language === 'ar';
  if (!isAr) return ageString; // لو إنجليزي سيبه زي ما هو

  // استخراج الأرقام من النص (مثلاً 1 و 7)
  const matches = ageString.match(/\d+/g);
  if (!matches) return ageString;

  const years = matches[0];
  const months = matches[1] || 0;

  return `${years} سنة و ${months} شهر`;
};

export const getFilters = (columns, t) => {
  return columns
    .filter(col => col !== "actions")
    .map(key => ({
      value: key,
      label: t(`table.${key}`),
    }));
};

export const downloadPDF = (element, filename="activity_report.pdf") => {
  const options = {
    margin: 10,
    filename: filename,
    image: { type: 'jpeg', quality: 0.98 },
    html2canvas: { scale: 2 },
    jsPDF: {
      unit: 'mm', // mm for A4 size
      format: 'a4',
      orientation: 'portrait', // or 'landscape'
    }
  };

  html2pdf().set(options).from(element).save();
};